import { render, staticRenderFns } from "./ProductRevealCheckboxV2.vue?vue&type=template&id=891f9cf8&scoped=true"
import script from "./ProductRevealCheckboxV2.vue?vue&type=script&lang=js"
export * from "./ProductRevealCheckboxV2.vue?vue&type=script&lang=js"
import style0 from "./ProductRevealCheckboxV2.vue?vue&type=style&index=0&id=891f9cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891f9cf8",
  null
  
)

export default component.exports